import { render, staticRenderFns } from "./OrderListXiao.vue?vue&type=template&id=4a54b571&scoped=true&"
import script from "./OrderListXiao.vue?vue&type=script&lang=js&"
export * from "./OrderListXiao.vue?vue&type=script&lang=js&"
import style0 from "./OrderListXiao.vue?vue&type=style&index=0&id=4a54b571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54b571",
  null
  
)

export default component.exports